var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIskraftLogoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 133 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 41,
    fill: "#0C4DA2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3608 15.9637L18.6099 14.0844V12.5291H13.3608V15.9637ZM18.4155 28.4061L18.4803 15.3805L13.296 17.9727V28.4709H18.4155V28.4061Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.135 17.0654C34.7461 14.214 32.7372 12.3995 28.3306 12.3995C24.3775 12.3995 21.5262 13.6308 21.5262 17.0654C21.5262 23.2866 30.5987 21.6017 30.5987 24.0642C30.5987 24.8419 29.6914 25.2307 28.3954 25.2307C27.8769 25.2307 27.4233 25.1011 26.9697 24.8419C26.5161 24.5827 26.2568 24.129 26.1272 23.5458H21.2021C21.3318 26.462 24.0535 28.4709 28.201 28.4709C32.5428 28.4709 35.5238 27.1748 35.5238 23.4162C35.5238 17.519 26.4513 19.0095 26.4513 16.6118C26.4513 16.0285 26.9697 15.7045 28.0714 15.7045C28.5898 15.7045 29.0434 15.7693 29.4322 16.0285C29.8211 16.223 30.0803 16.547 30.1451 17.1302H35.135",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3751 28.6005H43.4946V23.4162L44.7259 22.1201L48.5493 28.6005H54.7057L48.3549 18.4911L54.1224 12.3347H48.0309L43.4946 17.5838V12.3347H38.3751V28.6005Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8989 16.1581H64.2967C65.528 16.1581 66.3704 16.6766 66.3704 17.843C66.3704 18.9447 65.528 19.3983 63.9079 19.3983H61.8989V16.1581ZM63.6486 22.8977C66.0464 22.8977 66.4352 23.6106 66.4352 25.6843C66.4352 27.11 66.5648 28.1468 66.6944 28.5357H71.9435V28.0172C71.3603 28.0172 71.4251 27.3044 71.4251 25.1659C71.4251 21.9257 70.3882 21.4721 68.7682 20.8888C70.5827 20.3704 71.4251 18.8151 71.4251 16.9358C71.4251 13.7604 69.6754 12.3347 64.4263 12.3347H56.9091V28.5357H62.0934V22.8977H63.6486Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7379 22.8977H80.4977L82.1178 17.0654L83.7379 22.8977ZM78.9424 28.4061L79.5256 26.2675H84.6451L85.2283 28.4061H90.3478L84.7099 12.2051H79.4608L73.8229 28.4061H78.9424Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3467 28.6005V22.8977H102.985V19.0743H97.3467V16.1581H104.41V12.3347H92.1624V28.6005H97.3467Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.512 16.6118H110.113V28.6005H115.297V16.6118H119.963V12.3347H105.512V16.6118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIskraftLogoBg);
export default __webpack_public_path__ + "static/media/iskraftLogoBg.6b15db7d.svg";
export { ForwardRef as ReactComponent };